import api from './api';

const purchaseReportService = {
  getDocumentRegister: async (params = {}) => {
    const response = await api.get('/compras/reports/document-register', { params });
    return response.data;
  },

  getPriceTrackingDashboard: async (params = {}) => {
    const response = await api.get('/compras/reports/price-tracking/dashboard', { params });
    return response.data;
  },

  getPriceTrackingHistory: async (params = {}) => {
    const response = await api.get('/compras/reports/price-tracking/history', { params });
    return response.data;
  },

  getPriceTrackingProduct: async (productId, params = {}) => {
    const response = await api.get(`/compras/reports/price-tracking/product/${productId}`, { params });
    return response.data;
  },
};

export default purchaseReportService;
